export enum MaterialVariant {
  Material = "material",
  StockBatch = "material_stock_batch",
  MaterialItem = "material_item",
}
